import { useParams } from 'react-router-dom';
import { Zap } from 'lucide-react';

import { SidebarLayout } from '../../SidebarLayout';

/**
 * This is the main integration section that shows the integrations in the sidebar
 * @returns
 */
export const IntegrationsSection = () => {
  const { projectId } = useParams();
  return (
    <SidebarLayout.SidebarMainLayout.ListNavLink
      key="integrations"
      to={`/projects/${projectId}/integrations`}
      label="Integrations"
      iconSvg={<Zap size={20} />}
    />
  );
};
